/* FirmBranding — /admin/firm-branding
   Phase 1: Section shell with internal tab bar.
   Phase 2: Firm Details and Locale Settings tabs fully implemented.
   Phase 3: Logos & Letterhead tab fully implemented.
   Phase 4: Brand Colors tab fully implemented.
   Phase 5: Email Signature tab fully implemented.
   Phase 6: Business Hours tab fully implemented. */
import { useState } from 'react';
import css from '../../AdminPage.module.css';
import localCss from './FirmBranding.module.css';
import FirmDetails from './tabs/FirmDetails';
import BrandColors from './tabs/BrandColors';
import EmailSignature from './tabs/EmailSignature';
import BusinessHours from './tabs/BusinessHours';
import LocaleSettings from './tabs/LocaleSettings';
import LogosLetterhead from './tabs/LogosLetterhead';

type Tab = 'details' | 'colors' | 'logos' | 'signature' | 'locale' | 'hours';

const TABS: { id: Tab; label: string; icon: string; phase: number }[] = [
  { id: 'details', label: 'Firm Details', icon: '🏢', phase: 2 },
  { id: 'colors', label: 'Brand Colors', icon: '🎨', phase: 4 },
  { id: 'logos', label: 'Logos & Letterhead', icon: '🖼️', phase: 3 },
  { id: 'signature', label: 'Email Signature', icon: '✍️', phase: 5 },
  { id: 'locale', label: 'Locale Settings', icon: '🌍', phase: 2 },
  { id: 'hours', label: 'Business Hours', icon: '🕐', phase: 6 },
];

export default function FirmBranding() {
  const [tab, setTab] = useState<Tab>('details');

  return (
    <div>
      {/* ── Header ── */}
      <div className={css.sectionHeader}>
        <div>
          <h2 className={css.sectionTitle}>🏢 Firm Branding</h2>
          <p className={css.sectionSubtitle}>
            Org-wide identity, colours, logos, email signature, and locale preferences.
          </p>
        </div>
      </div>

      {/* ── Tab bar ── */}
      <div className={localCss.tabBar}>
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`${localCss.tab} ${tab === t.id ? localCss.tabActive : ''}`}
            onClick={() => setTab(t.id)}
          >
            <span>{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      {/* ── Tab panels ── */}
      <div className={localCss.tabPanel}>
        {tab === 'details' && <FirmDetails />}
        {tab === 'colors' && <BrandColors />}
        {tab === 'logos' && <LogosLetterhead />}
        {tab === 'signature' && <EmailSignature />}
        {tab === 'locale' && <LocaleSettings />}
        {tab === 'hours' && <BusinessHours />}
      </div>
    </div>
  );
}
